import "@css/app.css";
import "./vue-loader";
import "./order2023";

import "./price-map";
import "./lottie";
import "./swiper";

import Alpine from "alpinejs";

window.Alpine = Alpine;
Alpine.start();

function setupScrollToForm(formSelector, offset, orderFormSelector) {
    const scrollToButton = document.querySelector(`a[href="${formSelector}"]`);
    if (scrollToButton) {
        scrollToButton.addEventListener("click", (e) => {
            e.preventDefault();
            const orderForm = document.querySelector(orderFormSelector);
            if (orderForm) {
                const scrollOffset = orderForm.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: scrollOffset - offset,
                    behavior: "smooth"
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    setupScrollToForm('#bestill', 160, '.order-form');
    setupScrollToForm('#bestillbedrift', 0, '.companyorder-component');

    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
    var lazyIframes = [].slice.call(document.querySelectorAll('iframe[loading="lazy"]'));

    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting && video.target.classList.contains("lazy")) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                }
            });
        }, {
            rootMargin: '1440px 0px'
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });

        var lazyIframeObserver = new IntersectionObserver(function (iframes, observer) {
            iframes.forEach(function (iframe) {
                if (iframe.isIntersecting && iframe.target.getAttribute('loading') === 'lazy') {
                    iframe.target.src = iframe.target.dataset.src;
                    iframe.target.setAttribute('loading', 'eager');
                }
            });
        }, {
            rootMargin: '1440px 0px'
        });

        lazyIframes.forEach(function (lazyIframe) {
            lazyIframeObserver.observe(lazyIframe);
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    /*Get all anchor links, you can be more specific or use a classname to be sure it only selects the links you want.*/
    document.querySelectorAll('a[href^="#"]').forEach(el => {
        const anchor = el.getAttribute('href')?.trim();
        if(anchor != '') {
            el.addEventListener('click', (evt) => {
                evt.preventDefault();

                const target = document.querySelector(anchor);
                if(target) {
                    window.scrollTo({
                        top: target.offsetTop - 50,
                        behavior: "smooth"
                    });
                    history.pushState({}, "", anchor);
                }
            });
        }
    });
});

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}
